<template>
  <div class="flex flex-col h-screen min-h-full items-center justify-center">
    <!-- Brand Logo & Slogan -->
    <div class="flex w-full flex-col mb-12">
      <div class="flex justify-center items-center">
        <img
          :src="logoUrl"
          alt="AI lean Logo"
          role="brand-logo"
          class="h-5"
        >

        <h1
          class="text-xl font-bold text-gray-700 dark:text-muted-300 m-0 ml-2 leading-none"
        >
          AI lean
        </h1>
      </div>

      <h2 class="text-4xl font-bold text-center">
        Automated Lien <br> to Auction
      </h2>
    </div>

    <transition
      name="fade"
      mode="out-in"
    >
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'PublicViewComponent',
  computed: {
    logoUrl() {
      return document.documentElement.classList.contains('dark')
        ? '/assets/img/logo-dark.svg'
        : '/assets/img/logo.svg';
    }
  }
};
</script>

<style scoped>

</style>
